export default {
    "app_name": import.meta.env.VITE_APP_SITE_NAME,
    "shopping_agent": "Einkaufsagent",
    "forwarding": "Weiterleitung",
    "services": "Dienstleistungen",
    "about": "Über uns",
    "expert_buy": "Expertenkauf",
    "shipping_calculator": "Versandkostenrechner",
    "customer_review": "Kundenbewertungen",
    "dropshipping": "Dropshipping",
    "business_service": "Geschäftsservice",
    "trusted_seller": "Vertrauenswürdige Verkäufer",
    "blog": "Blog",
    "user_guides": "Benutzerhandbücher",
    "terms_of_service": "Nutzungsbedingungen",
    "terms_of_shipping": "Versandbedingungen",
    "privacy_policy": "Datenschutzrichtlinie",
    "faq": "Häufig gestellte Fragen",
    "home": "Startseite",
    "notice": "Mitteilungen",
    "cart": "Warenkorb",
    "me": "Mein Konto",
    "service_menu": "Servicemenü",
    "account": "Konto",
    "user_center": "Benutzerzentrum",
    "my_order": "Meine Bestellungen",
    "my_store": "Mein Shop",
    "log_out": "Abmelden",
    "sign_in": "Anmelden",
    "sign_up": "Registrieren",
    "compensation_taxation": "Entschädigung & Besteuerung",
    "tok_forum": "Forum",
    "get_community_help": "Treten Sie unserem Forum bei",
    "community_des": "Treten Sie unserem Forum bei, um Hilfe zu erhalten und anderen zu helfen",
    "page_home": {
        "title": "Ihr ultimatives Ziel",
        "description": "Chinesischer Einkaufsagent",
        "search_product_text": "Produkt-URL",
        "timeline": [
            {
                "title": "Bestellung aufgeben",
                "subtitle": "Auswahl & Kauf"
            },
            {
                "title": "Pakete versenden",
                "subtitle": "Qualitätskontrolle & internationaler Versand"
            },
            {
                "title": "Empfangen",
                "subtitle": "Empfangen & Teilen"
            }
        ],
        "cards": [
            ["Registrieren", "und einen 350€ Gutschein erhalten!"],
            ["Anleitung", "für Anfänger"],
            ["Treten Sie uns bei", "auf Reddit und Discord"]
        ],
        "shop_chinese": {
            "title": "Kaufen Sie auf chinesischen E-Commerce-Websites",
            "cards": [
                {
                    "title": "Geben Sie Ihre Bestellungen auf",
                    "description": "Genießen Sie problemloses Einkaufen für jedes Produkt aus China, online oder offline verfügbar. Um eine Bestellung aufzugeben, fügen Sie einfach den Produktlink ein. Genießen Sie unseren kompletten Service, von der Suche bis zum Kauf, mit absoluter Leichtigkeit."
                },
                {
                    "title": "Versand zum NiuniuBox-Lager",
                    "description": "Kaufen Sie über unseren Service bei verschiedenen Verkäufern ein, und wir werden Ihre Einkäufe effizient bündeln. Alle Artikel werden an das NiuniuBox-Lager in China versendet, was den Prozess für Sie vereinfacht."
                },
                {
                    "title": "Qualitätskontrolle",
                    "description": "Sobald Ihre Produkte im NiuniuBox-Lager ankommen, durchlaufen sie eine strenge Qualitätskontrolle. Unser Team prüft jeden Artikel sorgfältig auf Mängel und stellt die Konformität in Größe, Farbe usw. sicher. Mit NiuniuBox können Sie sich auf unseren engagierten After-Sales-Service verlassen."
                },
                {
                    "title": "Internationaler Versand",
                    "description": "Wählen Sie die Produkte aus Ihrem Lagerbestand aus und bündeln Sie sie einfach in einem Paket. Mit den zuverlässigen internationalen Versanddiensten von NiuniuBox werden Ihre Einkäufe direkt an Ihre Haustür geliefert. Genießen Sie den Komfort eines erstklassigen Versandservices."
                }
            ]
        },
        "bottom": [
            {
                "title": "Produkte in Hülle und Fülle",
                "description": "Wir finden für Sie vielfältige und kostengünstige Produkte aus China"
            },
            {
                "title": "Reduzierte Kosten",
                "description": "Einmalige Versandkosten für Produkte von verschiedenen Verkäufern, alle in einem Paket gebündelt"
            },
            {
                "title": "Qualitätsservice",
                "description": "Wir schätzen Ihre Treue und unser Ziel ist es, außergewöhnlichen Service und Support zu bieten"
            },
            {
                "title": "Schnelle Antwort",
                "description": "Garantierte Antwort auf alle Ihre Fragen zu unserem Service"
            }
        ]
    },
    "page_shopping": {
        "shopping_des": "Einkaufen aus China",
        "shopping_step": "1.Finden & Produkt suchen 2.Artikel bezahlen 3.Wir kaufen für Sie ein 4.Versand bezahlen 5.Wir versenden für Sie",
        "category": "Kategorie",
        "load_more_items": "Weitere Artikel laden",
        "note": "Haftungsausschluss: Alle Produkte, die für unseren Einkaufsagenten-Service auf unserer Website verfügbar sind, stammen von Drittanbieter-Shopping-Plattformen und werden nicht direkt von uns verkauft. Daher sind wir nicht verantwortlich für Probleme, die durch die Verletzung von geistigen Eigentumsrechten oder Urheberrechten der Waren verursacht werden.",
        "bottom_text": "Als professioneller Taobao-Agent helfen wir Ihnen, zahlreiche Produkte zu sehr günstigen Preisen von den größten Einkaufsseiten Chinas zu kaufen. Wir sind Ihr Taobao-Agent, um Artikel von Taobao.com, 1688.com zu finden, zu kaufen, zu prüfen und zu liefern. Unser Angebot umfasst die Beschaffung in China, den Kauf und den internationalen Versand. Wir bieten die größten Rabatte für den internationalen Versand von China in alle Länder, einschließlich USA, Kanada, Großbritannien, Australien, Frankreich, Singapur, Mexiko, Brasilien, Chile usw. Wo auch immer Sie sind, wir liefern die Pakete direkt an Ihre Haustür. Wir bieten Online-Tracking-Informationen für alle Sendungen. Wir haben professionelle Kundendienstmanager, die Ihnen helfen, erfolgreich einzukaufen und zu versenden.",
        "process_data": "Daten verarbeiten",
        "process_des": "Sie können alles über Ihre Bestellung erfahren. Wann immer Sie sich Sorgen machen, haben wir Daten, um Ihnen alles zu erzählen."
    },
    "meta": {
        "index_title": "Taobao Agent | Tmall Agent | 1688 Agent | Taobao auf Deutsch | Einkaufsagent | China Spediteur",
        "index_des": "Wir sind eine chinesische Einkaufsagenten-Plattform. Wir helfen Kunden, Produkte auf Taobao zu kaufen. Der Kauf Ihrer Lieblingsartikel aus China war noch nie so bequem und einfach.",
        "shopping_agent_title": "Einkaufsagent",
        "shopping_agent_des": "Kaufen Sie chinesische Produkte mit einem Einkaufsagenten. Taobao-Agent, 1688-Agent, Weidian-Agent, Yupoo-Agent.",
        "forwarding_title": "Spediteur - Versenden Sie Ihr Paket aus China",
        "forwarding_des": "Professionelle globale Speditionsplattform mit Speditionslagern, die professionelle Logistikdienstleistungen in die USA, nach Großbritannien, Kanada, Deutschland, Australien, Singapur, Mexiko und in andere Länder bietet, weltweiter Versand",
        "expert_buy_title": "Expertenkauf",
        "expert_buy_des": "Kaufen Sie Produkte über einen Taobao-Agenten, importieren Sie aus China. Niedrigste Versandpreise. Keine Servicegebühren.",
        "calculator_title": "Schätzung der internationalen Logistikkosten",
        "calculator_des": "Wir helfen Ihnen, die globalen Logistikkosten zu schätzen. Erschwinglicher Logistikservice. Schnellster Logistikservice.",
        "trusted_seller_title": "Vertrauenswürdige Verkäufer",
        "trusted_seller_des": "Vertrauenswürdige Verkäufer: Kaufen Sie bei diesen Verkäufern, und wir versenden für Sie. Taobao-Verkäufer, Weidian-Verkäufer."
    },
    "my_parcel": {
        "internationalParcels": "Internationale Pakete",
        "trackYourInternationalShipments": "Verfolgen Sie Ihre internationalen Sendungen und legen Sie Versandpräferenzen fest",
        "pleaseSelect": "Bitte auswählen",
        "yourRemark": "Ihre Bemerkung",
        "startDate": "Startdatum",
        "endDate": "Enddatum",
        "alertTrackParcels": "Verfolgen Sie Ihre Pakete hier. Pakete mit dem Status 'Versandbereit' wurden verpackt und vermessen und sind bereit für den Versand.",
        "noPackagesToShip": "Sie haben keine Pakete zum Versenden",
        "parcel": "Paket",
        "parcelID": "Paket-ID:",
        "shippingLabel": "Versandkosten:",
        "pending": "ausstehend",
        "finalFee": "Endgebühr:",
        "discount": "Rabatt:",
        "coupon": "Gutschein:",
        "created": "Erstellt am:",
        "status": "Status",
        "shippingMethod": "Versandmethode",
        "notConfiguredYet": "Noch nicht konfiguriert",
        "products": "Produkt(e)",
        "measured": "Gemessen",
        "estimated": "Geschätzt",
        "dimensions": "Abmessungen:",
        "weightInformation": "Gewichtsinformationen",
        "billingWeight": "Abrechnungsgewicht:",
        "na": "N/A",
        "actual": "Tatsächlich:",
        "volume": "Volumen:",
        "action": "Aktion",
        "configureShippingMethod": "Versandmethode konfigurieren",
        "payShipping": "Versand bezahlen",
        "track": "Verfolgen",
        "address": "Adresse",
        "shipping": "Versand:",
        "configure": "Konfigurieren",
        "pay": "Bezahlen",
        "viewMoreProducts": "Weitere Produkte in diesem Paket ansehen",
        "orderID": "Bestell-ID:",
        "quantity": "Menge:",
        "times": "x",
        "addressLabel": "Adresse",
        "yourRemarkTitle": "Ihre Bemerkung",
        "parcelRemarkTitle": "Paketbemerkung",
        "noRemarks": "Keine Bemerkungen für dieses Paket",
        "parcelImages": "Paketbilder",
        "failedToLoad": "Laden fehlgeschlagen",
        "noImages": "Keine Bilder für dieses Paket verfügbar",
        "productsInParcel": "Produkte im Paket",
        "type": "Typ:",
        "noProducts": "Keine Produktdetails für dieses Paket verfügbar",
        "configureShipping": "Versand konfigurieren",
        "alertPackagePrepared": "Ihr Paket wurde vorbereitet. Wählen Sie nun Ihre Versandmethode und geben Sie Ihre Lieferadresse an.",
        "packageDetails": "Paketdetails",
        "readyForShipping": "Versandbereit",
        "actualWeight": "Tatsächliches Gewicht:",
        "actualDimensions": "Tatsächliche Abmessungen:",
        "packagingNotes": "Verpackungshinweise:",
        "step1SubmitAddress": "Schritt 1: Adresse senden",
        "select": "Auswählen",
        "recipientName": "Empfängername",
        "email": "E-Mail",
        "phoneNumber": "Telefonnummer",
        "country": "Land",
        "city": "Stadt",
        "stateProvince": "Bundesland/Provinz",
        "zipCode": "Postleitzahl",
        "selectShippingMethod": "Versandmethode auswählen",
        "selectCountryFirst": "Wählen Sie zuerst das Land aus",
        "selectedShippingMethod": "Ausgewählte Versandmethode",
        "estimatedDelivery": "Geschätzte Lieferzeit",
        "estimatedFee": "Geschätzte Gebühr:",
        "changeShippingMethod": "Versandmethode ändern",
        "remark": "Bemerkung",
        "shippingRemarkPlaceholder": "CPF / CNPJ / Steuer-ID / Versandbemerkung",
        "saveAddress": "Adresse speichern",
        "saveAddressHint": "Speichern Sie diese Adresse in Ihrem Adressbuch für die zukünftige Verwendung",
        "submitShippingConfiguration": "Versandkonfiguration senden",
        "parcelDetailsTitle": "Paketdetails",
        "statusSection": "Status",
        "actions": "Aktionen",
        "parcelDetails": "Paketdetails",
        "trackingInfo": "Tracking-Informationen",
        "addressInfo": "Adressinformationen",
        "costDetails": "Kostendetails",
        "costPending": "ausstehend",
        "shippingMethodNotConfigured": "Versandmethode nicht konfiguriert",
        "packageDimensions": "Paketabmessungen",
        "measuredDimensions": "Gemessene Abmessungen",
        "estimatedDimensions": "Geschätzte Abmessungen",
        "length": "Länge:",
        "width": "Breite:",
        "height": "Höhe:",
        "totalVolume": "Gesamtvolumen:",
        "volumetricWeight": "Volumengewicht:",
        "weightCalculation": "Gewichtsberechnung",
        "weightCalcVolumeUsed": "Verwendetes Volumengewicht (das höhere)",
        "weightCalcActualUsed": "Verwendetes tatsächliches Gewicht (das höhere)",
        "billingWeightTooltip": "Dies ist das für die Abrechnung verwendete Gewicht (das höhere von tatsächlichem und Volumengewicht)",
        "remarks": "Bemerkungen",
        "delivery_number": "Paket-ID"
    },
    "footer": {
        "supportTitle": "Support",
        "support": ["Über uns", "Kontakt", "Servicegebühren", "Versandkosten"],
        "servicesTitle": "Dienstleistungen",
        "services": ["Taobao-Einkauf", "Yupoo-Agent", "Weidian-Agent", "Produktbeschaffung"],
        "tutorialTitle": "Anleitung",
        "tutorial": ["Einkaufsführer", "Unser Blog", "Versandkosten"],
        "resourcesTitle": "Ressourcen",
        "resources": ["Versandrichtlinie", "Rückerstattungen & Rückgaben", "Datenschutzrichtlinie", "Nutzungsbedingungen"],
        "followTitle": "Folgen Sie uns",
        "follow": ["Youtube", "TikTok", "Facebook", "Quora", "Twitter"],
        "copyright": "© 2025 NiuNiuBox - Hong Kong Niuniubox Technology Co., Limited",
        "paymentMethods": ["PayPal", "American Express", "Discover", "JCB", "Mastercard", "VISA"]
    },
    "sidebar_titles": ["BENUTZERPROFIL", "BESTELLUNGEN & VERSAND", "FINANZEN", "KONTO"],
    "sidebar": ["Konto", "Bestellung", "Lager", "Probe", "Paket", "Adressen", "Stornieren", "Verlauf", "Guthaben", "Nachrichten", "Gutschein", "Einstellungen", "Partnerprogramm"],
    "page_order_history": {
        "title": "Bestellverlauf",
        "search": {
            "order_number_placeholder": "Bestellnummer",
            "product_name_placeholder": "Produktname",
            "remark_placeholder": "Bemerkung",
            "style_sku_placeholder": "Stil/SKU",
            "start_date_placeholder": "Startdatum",
            "end_date_placeholder": "Enddatum",
            "status_placeholder": "Bitte auswählen"
        },
        "buttons": {
            "search": "Suchen",
            "pay_shopping_orders": "Einkaufsbestellungen bezahlen",
            "pay_order": "Bestellung bezahlen",
            "view_order": "Bestellung ansehen",
            "item_photos": "Artikelfotos",
            "view_product": "Produkt ansehen"
        },
        "table": {
            "empty_text": "Sie haben noch keine Bestellungen.",
            "header": {
                "image": "Bild",
                "details": "Details",
                "product": "Produkt",
                "action": "Aktion"
            },
            "body": {
                "order": "Bestellung:",
                "total": "Gesamt:",
                "type": "Typ:",
                "status": "Status:",
                "time": "Datum:",
                "style": "Stil:",
                "quantity": "Menge:",
                "remark": "Bemerkung:",
                "name": "Name:"
            }
        },
        "qc_dialog": {
            "title": "Qualitätskontrollfotos",
            "notice": "Ab August bieten wir keinen QC-Fotoservice mehr an.",
            "empty_description": "Ihr Artikel ist noch nicht in unserem Lager angekommen."
        }
    },
    "navbar": {
        "items": ["Versandkosten schätzen", "Partnerprogramm", "Kontakt", "Anleitung"],
        "cart": "Warenkorb",
        "login": "Anmelden",
        "register": "Registrieren",
        "logout": "Abmelden",
        "no": "Nein",
        "logout_confirm": "Sind Sie sicher, dass Sie sich abmelden möchten?",
        "search": "Suchen",
        "searchPlaceholder": "Produkt-URL",
        "dropdown": ["Benutzerzentrum", "Nachricht", "Bestellung", "Im Lager", "Meine Proben", "Meine Pakete", "Bestellung stornieren", "Abmelden"],
        "me": "Ich",
        "home": "Startseite",
        "menu": "Menü",
        "notice": "Mitteilungen"
    },
    "page_my_order": {
        "product_pic": "Produktbild",
        "product_qc": "QC-Foto",
        "store_order_no": "Shop-Bestellnummer",
        "type": "Typ",
        "details": "Ansehen",
        "remark": "Bemerkung",
        "process": "In Bearbeitung",
        "cn_track": "CN-Tracking",
        "pay_order": "Bestellung bezahlen",
        "search": "Suchen"
    },
    "page_calculator": {
        "des": "Weltweiten Versandpreis berechnen",
        "item_category": "Produktkategorie",
        "product_weight": "Gewicht",
        "product_length": "Länge",
        "product_width": "Breite",
        "product_height": "Höhe",
        "check": "Jetzt prüfen",
        "cost_note": "Hinweis: Das Paketgewicht darf für UPS/DHL/FedEx nicht weniger als 2,5 kg betragen. Andernfalls kann es nur per Small Parcel Line versendet werden.",
        "about_service": "Unser Versandkostenrechner ist eine ergänzende Funktion, die wir auf unserer Website als Teil unserer Einkaufsagenten- und internationalen Kurierdienste anbieten. Mit unserem Versandkostenrechner können Sie die ungefähren Versandkosten basierend auf den Abmessungen Ihrer Produkte oder Pakete und Ihrem Zielland schätzen. Sie können unseren Rechner auch verwenden, um die verschiedenen für Ihr Zielland verfügbaren Versandunternehmen sowie deren geschätzte Versandzeiten zu überprüfen.",
        "service_title": "Über den Rechner",
        "common_goods": "Allgemeine Waren",
        "brand_goods": "Markenprodukte",
        "liquid_goods": "Flüssige Produkte",
        "battery_goods": "Produkte mit Batterien",
        "shipping_method": "Versandmethode",
        "delivery_time": "Lieferzeit",
        "warehouse": "Lager",
        "estimated_cost": "Geschätzte Kosten",
        "method": "Methode"
    },
    "page_message": {
        "title": "Nachricht",
        "des": "Sie sollten auf diesen Teil der Nachrichten achten, da wir Ihnen eine Nachricht oder eine E-Mail senden werden."
    },
    "page_cart": {
        "title": "Mein Warenkorb",
        "item": "Artikel",
        "product": "Produkt",
        "price": "Preis",
        "quantity": "Menge",
        "freight": "Fracht",
        "total": "Gesamt",
        "info": "Informationen",
        "operate": "Bedienen",
        "pay_now": "Jetzt bezahlen",
        "confirm_buy": "Kauf bestätigen?",
        "yes": "Ja",
        "no": "Nein"
    },
    "page_settlement": {
        "title": "Bestätigen Sie Ihre Bestellung",
        "information": "Hinweis",
        "note_line1": "1. Produktfotos kostenlos machen",
        "note_line2": "2. Der Zahlungsbetrag beinhaltet die Warenkosten, die Zahlungsabwicklungsgebühr und die Servicegebühr",
        "note_line3": "3. Wir werden Sie per E-Mail über den Bestellfortschritt informieren. Bitte überprüfen Sie diese rechtzeitig",
        "note_line4": "4. Wenn Ihre Pakete im Lager ankommen, müssen Sie die Versandkosten bezahlen",
        "note_line5": "5. Sie müssen für jede Zahlung eine zusätzliche Gebühr bezahlen (PayPal)"
    },
    "page_shopping_payment": {
        "title": "Erste Zahlung für Produkte",
        "des": "Hinweis: Auf dieser Seite können nur die Produkte bezahlt werden. Die Versandkosten werden auf der Seite #Internationale Pakete# bezahlt.",
        "total": "Gesamt",
        "order_no": "Bestellung",
        "pay_now": "Zur Kasse",
        "shopping_notice": "Wichtiger Hinweis:"
    },
    "page_person": {
        "account": "Konto",
        "user_center": "Benutzerzentrum",
        "wallet": "Brieftasche",
        "orders": "Bestellungen",
        "my_order": "Meine Bestellung",
        "my_warehouse": "Im Lager",
        "my_parcel": "Internationale Pakete",
        "address_book": "Adressbuch",
        "online_store": "Online-Shop",
        "my_store": "Mein Shop",
        "activity": "Aktivität",
        "invite": "Einladen",
        "coupons": "Gutscheine"
    },
    "page_seller": {
        "title": "Vertrauenswürdiger Verkäufer",
        "buy_hanfu_title": "Kaufen Sie chinesische Hanfu von diesen Verkäufern, und wir versenden Ihr Paket",
        "buy_sneaker_title": "Kaufen Sie Turnschuhe von diesen Verkäufern, und wir versenden Ihr Paket",
        "buy_cosplay_title": "Kaufen Sie Cosplay-Produkte von diesen Verkäufern, und wir versenden Ihr Paket",
        "step_line1": "1. Finden Sie Produkte von diesen Verkäufern",
        "step_line2": "2. Senden Sie die Einkaufsbestellung ab",
        "step_line3": "3. Wir versenden es an Sie"
    },
    "page_profile": {
        "account": "Konto",
        "email": "E-Mail",
        "balance": "Guthaben"
    },
    "page_wallet": {
        "top_up": "Aufladen",
        "underpaid": "Unterbezahlt",
        "balance_details": "Guthabendetails",
        "time": "Zeit",
        "empty": "Keine Aufzeichnungen",
        "amount": "Betrag",
        "status": "Status",
        "info": "Informationen",
        "pay": "Bezahlen",
        "paid": "Bezahlt",
        "confirm": "Bestätigen",
        "discount_info": "Rabattinformationen",
        "and_get": "und erhalten Sie",
        "get_extra": "extra"
    },
    "in_warehouse": {
        "packages_in_warehouse": "Pakete im Lager",
        "product_name": "Produktname",
        "please_select": "Bitte auswählen",
        "remark": "Bemerkung",
        "style_sku": "Stil/SKU",
        "start_date": "Startdatum",
        "end_date": "Enddatum",
        "reset_selections": "Auswahl zurücksetzen",
        "select_products_alert": "Wählen Sie die Produkte aus, die zusammen verpackt werden sollen. Sobald sie verpackt sind, werden Sie benachrichtigt und können auf der Seite 'Meine Pakete' Versandoptionen auswählen.",
        "estimated_weight": "Geschätztes Gewicht: {weight} KG",
        "rehearse_parcel": "Paketprobe",
        "request_packaging": "Verpackung anfordern",
        "orders_not_arrived_alert": "Sie haben {count} Bestellungen, die noch nicht im Lager angekommen sind. Bitte bestätigen Sie, ob Sie jetzt verpacken oder auf alle Artikel warten möchten.",
        "table_empty_text": "Nichts auf dieser Seite. Sie können andere Seiten überprüfen.",
        "column_image": "Bild",
        "column_details": "Details",
        "order_label": "Bestellung:",
        "total_label": "Gesamt:",
        "type_label": "Typ:",
        "status_label": "Status:",
        "time_label": "Zeit:",
        "style_label": "Stil:",
        "quantity_prefix": "x",
        "no_remark": "Keine Bemerkung",
        "package_info_label": "Paketinformationen",
        "weight_label": "Gewicht:",
        "length_label": "Länge:",
        "width_label": "Breite:",
        "height_label": "Höhe:",
        "unit_kg": "KG",
        "unit_cm": "CM",
        "action_label": "Aktion",
        "view": "Ansehen",
        "photos": "Fotos",
        "cancel": "Abbrechen",
        "mobile_label_total": "Gesamt:",
        "mobile_label_type": "Typ:",
        "mobile_label_name": "Name:",
        "view_product": "Produkt ansehen",
        "mobile_style_label": "Stil:",
        "no_items_selected": "Keine Artikel ausgewählt",
        "submit_packaging_request": "Verpackungsanfrage senden",
        "dialog_request_packaging_title": "Verpackungsanfrage",
        "dialog_request_packaging_info": "Wir werden Ihre ausgewählten Artikel zusammen verpacken. Sobald sie verpackt sind, können Sie die tatsächlichen Abmessungen einsehen und unter 'Meine Pakete' Versandoptionen auswählen.",
        "packaging_instructions": "Verpackungsanweisungen",
        "placeholder_packaging_instructions": "Besondere Verpackungsanweisungen oder irgendwelche Bedenken?",
        "selected_items": "Ausgewählte Artikel",
        "packaging_note": "Hinweis: Nach dem Verpacken ermitteln wir die genauen Abmessungen und das Gewicht Ihres Pakets. Sie können dann Ihre Versandmethode auswählen und Ihre Adresse im Bereich 'Meine Pakete' angeben.",
        "new_packaging_process": "Neuer Verpackungsprozess",
        "step_request_packaging": "Verpackung anfordern:",
        "step_request_packaging_desc": "Wählen Sie Produkte aus und senden Sie die Verpackungsanfrage.",
        "step_warehouse_packaging": "Lagerverpackung:",
        "step_warehouse_packaging_desc": "Unser Personal wird Ihre ausgewählten Artikel verpacken.",
        "step_measurement": "Messung:",
        "step_measurement_desc": "Wir werden die genauen Abmessungen und das Gewicht Ihres Pakets messen.",
        "step_notification": "Benachrichtigung:",
        "step_notification_desc": "Sie werden benachrichtigt, wenn Ihr Paket fertig ist.",
        "step_shipping_setup": "Versandeinrichtung:",
        "step_shipping_setup_desc": "Gehen Sie zu 'Meine Pakete', um Versandoptionen auszuwählen und Ihre Adresse einzugeben.",
        "step_make_payment": "Zahlung vornehmen:",
        "step_make_payment_desc": "Bezahlen Sie den Versand basierend auf den tatsächlichen Paketabmessungen und dem Gewicht.",
        "confirm_packaging_title": "Verpackungsanfrage bestätigen",
        "confirm_packaging_text": "Sie sind dabei, die Verpackung für {count} Artikel anzufordern. Fortfahren?",
        "item_qc_photos": "Artikel QC Fotos",
        "empty_qc_desc": "Ihr Artikel ist noch nicht in unserem Lager angekommen.",
        "return_items_title": "Artikel zurücksenden",
        "return_items_text": "Die Rücksendung von Artikeln kann zusätzliche Kosten verursachen. Möchten Sie trotzdem fortfahren?",
        "number_of_items_to_return": "Anzahl der zurückzusendenden Artikel:",
        "confirm": "Bestätigen"
    },
    "page_address_book": {
        "title": "Mein Adressbuch",
        "buttons": {
            "add_new": "Neu hinzufügen",
            "save": "Adresse speichern"
        },
        "dialog": {
            "title": "Ihre Adresse hinzufügen",
            "alert": "Fügen Sie Ihre Adresse hinzu und sie kann beim nächsten Mal verwendet werden!",
            "form": {
                "contact_name": "Kontaktname",
                "address": "Adresse",
                "city": "Stadt",
                "province": "Bundesland/Provinz",
                "country": "Land",
                "country_placeholder": "Zielland auswählen",
                "zip_code": "Postleitzahl",
                "phone": "Telefon",
                "email": "E-Mail",
                "email_placeholder": "Empfohlen"
            }
        }
    },
    "page_wallet": {
        "header": {
            "title": "Brieftaschenübersicht",
            "subtitle": "Verwalten Sie Ihr Guthaben und Ihren Transaktionsverlauf"
        },
        "balance_card": {
            "label": "Verfügbares Guthaben",
            "currency": "USD",
            "top_up_button": "Guthaben aufladen"
        },
        "history": {
            "title": "Transaktionsverlauf",
            "count": "{count} Transaktionen",
            "empty": {
                "title": "Noch keine Transaktionen",
                "subtitle": "Ihr Transaktionsverlauf wird hier angezeigt"
            },
            "item": {
                "order_prefix": "Bestellung:",
                "balance_after_prefix": "Guthaben:",
                "note_prefix": "Hinweis:",
                "complete_payment_button": "Zahlung abschließen",
                "mobile": {
                    "order_id_label": "Bestell-ID:",
                    "balance_after_label": "Guthaben danach:",
                    "status_label": "Status:"
                }
            }
        },
        "top_up_dialog": {
            "title": "Aufladen",
            "form": {
                "amount_label": "Betrag eingeben (USD)",
                "quick_select_title": "Schnellauswahl des Betrags",
                "create_payment_button": "Zahlung erstellen"
            }
        }
    },
    "page_message_center": {
        "title": "Nachrichtenzentrale",
        "filters": {
            "all": "Alle",
            "unread": "Ungelesen",
            "read": "Gelesen",
            "search_placeholder": "Nachrichten suchen..."
        },
        "actions": {
            "mark_all_read": "Alle als gelesen markieren",
            "delete_all": "Alle Nachrichten löschen",
            "refresh": "Nachrichten aktualisieren"
        },
        "delete_confirm": {
            "title": "Diese Nachricht löschen?",
            "confirm_button": "Löschen",
            "cancel_button": "Abbrechen"
        },
        "empty_states": {
            "no_search_results": "Keine Nachrichten gefunden, die Ihrer Suche entsprechen.",
            "no_unread": "Sie haben keine ungelesenen Nachrichten.",
            "no_read": "Sie haben keine gelesenen Nachrichten.",
            "no_messages_yet": "Ihre Nachrichtenzentrale ist leer."
        }
    },
    "page_user_profile": {
        "tabs": {
            "profile": "Profil",
            "account_safety": "Kontosicherheit"
        },
        "profile_section": {
            "email": "E-Mail:",
            "gender": "Geschlecht:",
            "country": "Land:",
            "language": "Sprache:",
            "current_language": "Deutsch",
            "phone": "Telefon:",
            "birthday": "Geburtsdatum:",
            "vip_prefix": "VIP",
            "max_vip_level": "VIP5",
            "privilege_title": "Meine Privilegien",
            "privilege_table_header": "Level-Privileg"
        },
        "safety_section": {
            "modify_password_title": "Passwort ändern",
            "modify_password_desc": "Ein Passwort mit höherer Stufe macht Ihr Konto sicherer. Es wird empfohlen, Ihr Passwort regelmäßig zu ändern und Zahlen und Buchstaben einzuschließen.",
            "modify_password_button": "Passwort ändern"
        },
        "update_info_dialog": {
            "title": "Kontoinformationen aktualisieren",
            "account_name_label": "Kontoname",
            "phone_label": "Telefonnummer",
            "gender_label": "Geschlecht",
            "gender_placeholder": "Auswählen",
            "country_label": "Land",
            "country_placeholder": "Land auswählen",
            "birthday_label": "Geburtsdatum",
            "birthday_placeholder": "Auswählen",
            "save_button": "Informationen speichern"
        },
        "update_password_dialog": {
            "title": "Passwort aktualisieren",
            "old_password_label": "Altes Passwort",
            "new_password_label": "Neues Passwort",
            "confirm_password_label": "Passwort bestätigen",
            "save_button": "Speichern"
        }
    },
    "page_shipping_calculator": {
        "hero": {
            "title": "Ihr ultimativer chinesischer Einkaufsagent"
        },
        "form_card": {
            "title": "Versandkostenschätzung",
            "subtitle": "Geben Sie unten Ihre Paketdetails ein, um genaue Versandkosten zu erhalten",
            "country_label": "Zielland",
            "country_placeholder": "Land auswählen",
            "country_search_placeholder": "Ein Land suchen...",
            "no_countries_for_letter": "Keine Länder, die mit {letter} beginnen.",
            "no_countries_for_search": "Keine Länder für \"{query}\" gefunden.",
            "category_label": "Produktkategorie",
            "category_placeholder": "Kategorie auswählen",
            "select_main_category_first": "Wählen Sie zuerst eine Hauptkategorie aus.",
            "weight_label": "Gewicht (kg)",
            "length_label": "Länge (cm)",
            "width_label": "Breite (cm)",
            "height_label": "Höhe (cm)",
            "required_label": "Erforderlich",
            "optional_label": "(Optional)",
            "optional_placeholder": "Optional",
            "calculating_button": "Berechne...",
            "submit_button": "Versandkosten erhalten"
        },
        "summary": {
            "title": "Zusammenfassung der Versandanfrage",
            "sort_by": "Sortieren nach:",
            "sort_price": "Preis",
            "sort_time": "Transitzeit",
            "destination": "Ziel:",
            "weight": "Gewicht:",
            "dimensions": "Abmessungen:",
            "volume": "Volumen:",
            "categories": "Kategorien:"
        },
        "results": {
            "loading_text": "Verfügbare Versandoptionen werden berechnet...",
            "no_options_title": "Keine Versandoptionen verfügbar",
            "no_options_desc": "Für die eingegebenen Details und das Ziel wurden keine gültigen Versandoptionen gefunden. <br /> Bitte überprüfen Sie die Gewichts-, Abmessungs- und Produktkategoriebeschränkungen für das ausgewählte Land.",
            "initial_state_text": "Bitte geben Sie die erforderlichen Parameter (Land, Gewicht) ein und klicken Sie auf \"Versandkosten erhalten\".",
            "all_unavailable_info": "Alle Versandkanäle für diese Kombination sind nicht verfügbar. Details siehe unten.",
            "est_transit_time": "Geschätzte Transitzeit",
            "volume_weight": "Volumengewicht",
            "billing_weight": "Abrechnungsgewicht",
            "view_details_button": "Details anzeigen",
            "load_more_button": "Mehr laden ({count} verbleibend)",
            "unavailable_channels_title": "Nicht verfügbare Versandkanäle ({count})",
            "not_available_badge": "Nicht verfügbar",
            "reason_prefix": "Grund:"
        },
        "details_modal": {
            "overview_title": "Versandübersicht",
            "shipping_fee": "Versandgebühr",
            "description_title": "Servicebeschreibung",
            "no_description": "Keine Beschreibung verfügbar.",
            "restrictions_title": "Transportbeschränkungen",
            "category_restrictions_title": "Produktkategorie-Beschränkungen",
            "legend_can_send": "Kann gesendet werden",
            "legend_cannot_send": "Kann nicht gesendet werden",
            "can_send_subheading": "Kann gesendet werden:",
            "cannot_send_subheading": "Kann nicht gesendet werden:",
            "no_allowed_items": "Keine spezifischen erlaubten Artikel aufgeführt (es wird angenommen, dass allgemeine Waren in Ordnung sind, es sei denn, sie sind eingeschränkt)",
            "no_prohibited_items": "Keine spezifischen verbotenen Artikel aufgeführt (Standardverbote des Spediteurs gelten)",
            "rules_title": "Transportregeln",
            "weight_restriction_title": "Gewichtsbeschränkung",
            "dimension_restriction_title": "Abmessungsbeschränkung",
            "billing_rules_title": "Abrechnungsregeln",
            "tax_info_title": "Steuerinformationen",
            "additional_fees_title": "Zusätzliche Gebühren",
            "no_additional_fees": "Nicht angegeben (Standardgebühren des Spediteurs können anfallen)",
            "min_label": "Min:",
            "max_label": "Max:",
            "carrier_limit": "Spediteurlimit",
            "close_button": "Schließen"
        }
    },
    "page_shopping_guide": {
        "header": {
            "title": "Einkaufsführer",
            "description": "Anleitung zum Einkaufen auf Taobao, 1688, Weidian und Yupoo für Anfänger",
            "video_title": "Einkaufsprozess-Video"
        },
        "process": {
            "title": "Einkaufsprozess",
            "step1": {
                "title": "Schritt 1: Produkt auswählen",
                "description": "Finden Sie das gewünschte Produkt auf Taobao.com, 1688.com, Tmall.com oder Weidian."
            },
            "step2": {
                "title": "Schritt 2: Produkt suchen",
                "description": "Wenn Sie das gewünschte Produkt nicht finden können, zögern Sie nicht, unseren 24/7-Kundenservice um Hilfe zu bitten. Kopieren Sie den Produktlink und fügen Sie ihn auf der NiuNiuBox-Website ein. Wenn Sie die Taobao-App verwenden, finden Sie den Produktlink auch auf der Produktdetailseite von Taobao."
            },
            "step3": {
                "title": "Schritt 3: Größe/Farbe auswählen",
                "description": "Bestätigen Sie die Größe und Farbe des benötigten Produkts auf NiuNiuBox und fügen Sie es dann Ihrem Warenkorb hinzu."
            },
            "step4": {
                "title": "Schritt 4: Erste Zahlung",
                "description": "Gehen Sie zu Ihrem Warenkorb und schließen Sie die erste Zahlung für die ausgewählten Artikel ab."
            },
            "step5": {
                "title": "Schritt 5: Ihre Adresse senden",
                "description": "Sobald Sie die erste Zahlung abgeschlossen haben, kauft das NiuNiuBox-Team die Produkte für Sie. Nachdem alle Ihre Produkte in unserem Lager angekommen sind, müssen Sie Ihre Adresse angeben, damit wir Ihre Artikel in einem großen Karton verpacken können."
            },
            "step6": {
                "title": "Schritt 6: Zweite Zahlung",
                "description": "Nachdem wir Ihre Produkte verpackt haben, erhalten Sie eine E-Mail mit dem Paketgewicht und den Versandkosten. Sie müssen dann die internationalen Versandkosten bezahlen, und wir versenden Ihr Paket von unserem Lager in China an Ihre Adresse."
            },
            "step7": {
                "title": "Schritt 7: Warten auf Ihr Paket",
                "description": "Nachdem Ihr Paket versandt wurde, erhalten Sie innerhalb von 3 Tagen eine Sendungsverfolgungsnummer. Damit können Sie den Standort Ihres Pakets einsehen."
            }
        }
    },
    "page_contact_us": {
        "title": "Kontaktieren Sie uns",
        "support_email_label": "Kundensupport-E-Mail:"
    },
    "page_my_account": {
        "title": "Mein Konto",
        "profile_card": {
            "member_type": "Ordentliches Mitglied",
            "member_since": "Mitglied seit",
            "logout_confirm": "Sind Sie sicher, dass Sie sich abmelden möchten?",
            "top_up_button": "Aufladen",
            "orders_label": "Bestellungen",
            "coupons_label": "Gutscheine"
        },
        "balance_info": {
            "title": "Über Ihr Guthaben",
            "description": "Wenn Sie eine Bestellung stornieren, wird Ihr verbleibendes Guthaben automatisch auf Ihr Guthabenkonto überwiesen.",
            "highlight1": "Kaufen Sie weiterhin mit Ihrem Guthaben ein",
            "highlight2": "Kontaktieren Sie den Kundenservice für Rückerstattungen auf Ihr Zahlungskonto"
        },
        "quick_actions": {
            "title": "Schnellaktionen",
            "shopping_orders": "Einkaufsbestellungen",
            "in_warehouse": "Im Lager",
            "my_rehearsal": "Meine Probe",
            "my_parcels": "Meine Pakete",
            "my_balance": "Mein Guthaben",
            "messages": "Nachrichten",
            "my_coupons": "Meine Gutscheine",
            "cancel_order": "Bestellung stornieren"
        },
        "recent_orders": {
            "title": "Letzte Bestellungen",
            "view_all_button": "Alle anzeigen",
            "header_product": "Produkt",
            "header_amount": "Betrag",
            "header_date": "Datum",
            "header_status": "Status",
            "header_actions": "Aktionen",
            "quantity_prefix": "Menge:",
            "details_button": "Details"
        },
        "invitation": {
            "title": "Freunde einladen",
            "description": "Teilen Sie unsere Seite mit Freunden und verdienen Sie Belohnungen:",
            "copy_button": "Kopieren"
        }
    },
    "page_shopping_order": {
        "title": "Einkaufsbestellung",
        "search": {
            "order_number_placeholder": "Bestellnummer",
            "product_name_placeholder": "Produktname",
            "status_placeholder": "Bitte auswählen",
            "remark_placeholder": "Bemerkung",
            "style_sku_placeholder": "Stil/SKU",
            "start_date_placeholder": "Startdatum",
            "end_date_placeholder": "Enddatum",
            "search_button": "Suchen",
            "pay_button": "Einkaufsbestellungen bezahlen"
        },
        "info_alert": "Diese Seite zeigt Einkaufsbestellungen wie Taobao/1688/Weidian. Bitte wählen Sie die [Ausstehende Zahlung] Bestellungen aus und bezahlen Sie.",
        "table": {
            "empty_text": "Sie haben noch keine Einkaufsbestellungen",
            "header": {
                "image": "Bild",
                "details": "Details",
                "product": "Produkt",
                "action": "Aktion"
            },
            "body": {
                "order_prefix": "Bestellung:",
                "total_prefix": "Gesamt:",
                "type_prefix": "Typ:",
                "status_prefix": "Status:",
                "time_prefix": "Zeit:",
                "style_prefix": "Stil:",
                "quantity_prefix": "Menge:",
                "remark_prefix": "Bemerkung:",
                "name_prefix": "Name:"
            },
            "actions": {
                "pay_order": "Bestellung bezahlen",
                "view_order": "Bestellung ansehen",
                "item_photos": "Artikelfotos",
                "cancel_item": "Artikel stornieren",
                "view_product": "Produkt ansehen"
            }
        },
        "qc_dialog": {
            "title": "Artikel QC Fotos",
            "empty_text": "Ihr Artikel ist noch nicht in unserem Lager angekommen."
        },
        "return_dialog": {
            "title": "Artikel zurücksenden",
            "confirmation_text": "Die Rücksendung von Artikeln kann zusätzliche Kosten verursachen. Möchten Sie trotzdem fortfahren?",
            "quantity_label": "Anzahl der zurückzusendenden Artikel:",
            "cancel_button": "Abbrechen",
            "confirm_button": "Bestätigen"
        },
        "cancel_dialog": {
            "title": "Bestellung stornieren",
            "confirmation_text": "Wenn Sie diese Bestellung stornieren möchten, müssen Sie die Versandkosten tragen. Die Gebühr wird von Ihrer bereits geleisteten Zahlung abgezogen. Möchten Sie fortfahren?",
            "cancel_button": "Abbrechen",
            "confirm_button": "Bestätigen"
        }
    },
    "page_shipping_config": {
        "title": "Versandkonfiguration",
        "summary": {
            "destination": "Ziel:",
            "actual_weight": "Tatsächliches Paketgewicht:",
            "est_dimensions": "Geschätzte Abmessungen:",
            "weight_note": "*Das geschätzte Paketgewicht basiert auf dem Produktgewicht, das tatsächliche Gewicht wird nach dem Wiegen bestimmt.",
            "product_types": "Produkttypen",
            "selected_method": "Ausgewählte Versandmethode:",
            "selected_method_none": "Keine",
            "est_fee": "Geschätzte Gebühr:"
        },
        "status": {
            "loading": "Verfügbare Versandoptionen werden berechnet...",
            "no_options": "Für das aktuelle Gewicht, die Abmessungen, die Produkttypen und das Land sind keine Versandoptionen verfügbar. <br />Bitte überprüfen Sie die Einschränkungen."
        },
        "options": {
            "select_sr_label": "Wählen Sie {channelName}",
            "shipping_fee": "Versandgebühr",
            "volume_weight": "Volumengewicht",
            "volume_weight_formula": "Volumengewicht (KG) = L*B*H (CM) / {denominator}",
            "billing_weight": "Abrechnungsgewicht",
            "billing_weight_details": "Basierend auf dem höheren Wert zwischen tatsächlichem Gewicht ({weight} kg) und Volumengewicht. Aufrundungen und Mindestwerte können gemäß den Kanalregeln gelten.",
            "transit_time": "Transitzeit",
            "hide_details_button": "Details ausblenden",
            "show_details_button": "Details anzeigen"
        },
        "details": {
            "category_restrictions_title": "Produktkategorie-Beschränkungen",
            "legend_can_send": "Kann gesendet werden",
            "legend_cannot_send": "Kann nicht gesendet werden",
            "can_send_subheading": "Kann gesendet werden:",
            "no_allowed_items": "Keine spezifischen erlaubten Artikel aufgeführt (es wird angenommen, dass allgemeine Waren in Ordnung sind, es sei denn, sie sind eingeschränkt)",
            "cannot_send_subheading": "Kann nicht gesendet werden:",
            "no_prohibited_items": "Keine spezifischen verbotenen Artikel aufgeführt (Standardverbote des Spediteurs gelten)",
            "rules_title": "Transportregeln",
            "weight_restriction_title": "Gewichtsbeschränkung",
            "min_label": "Min:",
            "max_label": "Max:",
            "carrier_limit": "Spediteurlimit",
            "dimension_restriction_title": "Abmessungsbeschränkung",
            "billing_rules_title": "Abrechnungsregeln",
            "tax_info_title": "Steuerinformationen",
            "additional_fees_title": "Zusätzliche Gebühren",
            "no_additional_fees": "Nicht angegeben (Standardgebühren des Spediteurs können anfallen)"
        },
        "confirm_button": "Bestätigen"
    },
    "page_parcel_details": {
        "loading": "Lade Paketdetails...",
        "overview": {
            "title": "Paketübersicht",
            "parcel_id": "Paket-ID",
            "payment_time": "Zahlungszeitpunkt",
            "status": "Status",
            "shipping_cost": "Versandkosten",
            "billing_weight": "Abrechnungsgewicht",
            "parcel_remark": "Paketbemerkung",
            "your_note": "Ihre Notiz"
        },
        "tracking": {
            "title": "Tracking-Informationen",
            "empty_text": "Noch keine Tracking-Informationen. Sie erhalten eine Tracking-Nummer, sobald der Versand erfolgt ist (~3 Tage)."
        },
        "items": {
            "title": "Produktartikel",
            "empty_text": "Keine Artikel gefunden",
            "header_order_image": "Bestellung / Bild",
            "header_product_details": "Produktdetails",
            "header_qc_photos": "QC Fotos",
            "order_prefix": "Bestellung:",
            "sku_prefix": "SKU:",
            "quantity_prefix": "Menge:",
            "note_prefix": "Notiz:"
        }
    },
    "page_affiliate": {
        "header": {
            "title": "30% Bonus-Boost",
            "description": "Basierend auf dem Versandbonus für neue Partner"
        },
        "commission": {
            "title": "Meine Werbeprovision",
            "invited_users": "Eingeladene Benutzer:",
            "new_affiliates": "Neue Partner:",
            "active_users": "Aktive Benutzer:"
        },
        "balance": {
            "title": "Mein Partner-Guthaben",
            "amount_withdrawn": "Abgehobener Betrag:",
            "withdrawn_button": "Abheben",
            "withdrawable_title": "Abhebbar",
            "board_earnings_title": "Board-Erstellungseinnahmen",
            "claim_button": "Einfordern"
        },
        "steps": {
            "step1": "Teilen Sie Einladungscodes mit Ihren Freunden",
            "step2": "Ein Freund hat eine Bestellung aufgegeben und das Paket erhalten",
            "step3": "Erhalten Sie die Provision"
        },
        "promotion_method": {
            "title": "Werbemethode",
            "mobile_description": "Regelbeschreibung Regelbeschreibung Regelbeschreibung",
            "desktop_description": "Die Provision, die Sie jeden Monat erhalten, wird direkt auf Ihr persönliches Konto überwiesen.",
            "invite_link_label": "Einladungslink:",
            "copy_link_button": "Link kopieren",
            "copy_code_button": "Einladungscode kopieren",
            "download_qr_button": "QR-Code herunterladen"
        }
    },
    "page_product_details": {
        "promo_banner": "Kaufen Sie kostengünstige Produkte von chinesischen E-Commerce-Websites und sparen Sie mehr Geld. Weltweiter Versand aus China.",
        "stats": {
            "sales": "Verkäufe:",
            "inventory": "Lagerbestand:"
        },
        "info": {
            "original_link": "Originallink",
            "processing_time": "Nach der Zahlung kaufen wir innerhalb von 12 Stunden für Sie ein.",
            "domestic_shipping": "Inlandsversand",
            "free_shipping": "Kostenloser Versand",
            "shipping_note": "Die lokalen Versandkosten vom Verkäufer zu unserem Lager in China."
        },
        "options": {
            "quantity": "Menge",
            "items_available": "{count} Artikel verfügbar",
            "order_remark": "Bestellbemerkung:",
            "order_remark_subtitle": "Fügen Sie Anweisungen oder spezielle Wünsche hinzu",
            "remark_placeholder": "Bitte hinterlassen Sie eine Nachricht an den Verkäufer, wie Farbe, Größe usw."
        },
        "actions": {
            "shipping_cost_estimate": "Versandkostenschätzung",
            "disclaimer_title": "Haftungsausschluss",
            "disclaimer_text": "Alle Produkte, die für den Einkaufsagenten-Service auf Niuniubox angezeigt werden, stammen von Drittanbieter-Shopping-Plattformen und werden nicht direkt von Niuniubox verkauft. Daher übernimmt Niuniubox keine rechtliche Verantwortung für Probleme, die durch die Verletzung von geistigen Eigentumsrechten und Urheberrechten der Waren verursacht werden.",
            "agreement_checkbox": "Ich habe gelesen und stimme zu",
            "buy_now": "Jetzt kaufen",
            "add_to_cart": "In den Warenkorb",
            "share": "Teilen"
        },
        "share_dialog": {
            "title": "Dieses Produkt teilen",
            "platform_facebook": "Facebook",
            "platform_whatsapp": "WhatsApp",
            "platform_wechat": "WeChat",
            "platform_discord": "Discord",
            "platform_email": "E-Mail",
            "copy_button": "Kopieren"
        },
        "sidebar": {
            "original_site": "Originalseite:",
            "why_title": "Warum Taobao, 1688, Weidian, Yupoo, Tmall?",
            "why_description": "Die Produkte auf diesen Plattformen sind sehr günstig. Wenn Sie möglichst wenig Geld für qualitativ hochwertige Produkte ausgeben möchten, ist der Kauf auf diesen Plattformen am kostengünstigsten. Wir bieten globale Logistikdienste per Luft- und Seefracht an.",
            "details_title": "Produktdetails",
            "empty_details": "Leere Produktdetails."
        },
        "loading": {
            "try_again": "Erneut versuchen",
            "note_title": "Hinweis:",
            "error_note_1": "1. Sie können uns kontaktieren, wenn Sie die Produktinformationen nicht sehen können.",
            "error_note_2": "2. Das Produkt ist vergriffen oder die Produkt-URL ist ungültig. Bitte überprüfen Sie Ihren Produktlink.",
            "error_note_3": "3. Unterstützte Plattformen: Taobao.com, 1688.com, Tmall.com, Weidian.com (unterstützt nur Produkt-URLs)"
        }
    },
    "shopping_steps": {
        "title": "So funktioniert's",
        "steps_data": [
            {
                "title": "Produkte finden",
                "des": "Durchsuchen Sie Millionen von Produkten von chinesischen Marktplätzen wie Taobao, 1688, Weidian, Tmall zu Großhandelspreisen"
            },
            {
                "title": "In den Warenkorb",
                "des": "Wählen Sie Ihre Artikel aus, wählen Sie Spezifikationen und fügen Sie sie für eine einfache Bestellverwaltung Ihrem Warenkorb hinzu"
            },
            {
                "title": "Zur Kasse gehen",
                "des": "Bezahlen Sie sicher für Ihre Artikel, und wir kaufen sie in Ihrem Namen bei verschiedenen Verkäufern"
            },
            {
                "title": "Lieferung erhalten",
                "des": "Wir versenden Ihr konsolidiertes Paket von China bis an Ihre Haustür mit vollständigen Tracking-Informationen"
            }
        ]
    }
}